import { Button, ButtonStyle, FormField, Spinner } from "@prequel/shared-components";

import { FormState } from "../LoginCard";

import { useCheckSSOEnabled, useGoogleOauthLogin } from "@/api/queries/auth";
import { GoogleIcon } from "@/assets/logos";

type OptionsCardProps = {
  setFormState: React.Dispatch<React.SetStateAction<FormState>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
};

const OptionsCard = ({ setFormState, email, setEmail }: OptionsCardProps) => {
  const checkSSOEnabled = useCheckSSOEnabled();
  const googleOauthLogin = useGoogleOauthLogin();

  const onContinueWithEmail = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkSSOEnabled.mutate(email);
    setFormState("PASSWORDLESS_SELECTED");
  };

  const logInWithGoogleOauth = () => {
    googleOauthLogin.mutate();
  };

  return (
    <form onSubmit={onContinueWithEmail} className="space-y-4">
      <div className="space-y-4">
        <Button
          key="google"
          className="w-full"
          type={ButtonStyle.TERTIARY}
          onClick={logInWithGoogleOauth}
          disabled={googleOauthLogin.isPending || googleOauthLogin.isSuccess}
          text={
            googleOauthLogin.isPending || googleOauthLogin.isSuccess ? (
              <div className="flex space-x-2.5">
                <Spinner.Inline className="mr-3" />
                <GoogleIcon className="h-5" />
                <span>Signing in with Google</span>
              </div>
            ) : (
              <div className="flex space-x-2.5">
                <GoogleIcon className="h-5" />
                <span>Continue with Google</span>
              </div>
            )
          }
        />
        <Button
          key="sso"
          className="w-full"
          type={ButtonStyle.TERTIARY}
          onClick={() => setFormState("SSO_SELECTED")}
          text={"Continue with SSO"}
        />
      </div>
      <div className="w-full border-b border-gray-300" />
      <FormField
        id="email"
        key="email"
        type="email"
        placeholder="you@yourcompany.com"
        value={email}
        label="Email"
        onChangeHandler={setEmail}
        required
        autoFocus
      />

      <Button className="w-full" submit disabled={checkSSOEnabled.isPending} text={"Continue with email"} />
    </form>
  );
};

export default OptionsCard;
